module.exports = __webpack_public_path__ + "68b0b11b51c72791fc138bfcfefbffe4.jpg";